import { createPaginator } from "@smithy/core";
import { GetSegmentDetectionCommand, } from "../commands/GetSegmentDetectionCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetSegmentDetection = createPaginator(RekognitionClient, GetSegmentDetectionCommand, "NextToken", "NextToken", "MaxResults");
